jQuery( $ => {
	$( '.qala-filters__tax-list__terms__term' ).on( 'click', function() {
		$( this ).siblings().addClass( 'expanded' );
		setCounter();
	} );

	$( '.qala-filters__load-more-button, .qala-filters__tax-list__active-terms' ).on( 'click', function() {
		setCounter();
	} );

	const $win = $( window );
	const $container = $( '.qala-filters__tax-list__terms' );

	$win.on( 'click.Bst', function( event ) {
		if ( 0 === $container.has( event.target ).length && ! $container.is( event.target ) ) {
			const $filterTerm = $( '.qala-filters__tax-list__terms__term' );

			$filterTerm.removeClass( 'open' );
			$filterTerm.removeClass( 'expanded' );
		} else {
			$( event.target ).closest( '.qala-filters__tax-list__terms__term' ).addClass( 'open' );
		}
	} );

	const partners = $( '.archive-partners .archive-partner' );

	if ( partners.length ) {
		setCounter();
	}

	function setCounter() {
		setTimeout( function() {
			const partnersCurrent = $( '.archive-partners .archive-partner' );

			$( '.counter .number' ).text( partnersCurrent.length );
		}, 1000 );
	}

	$( '.qala-filters__tax-list__active-terms__term' ).on( 'click', function() {
		setCounter();
	} );
}
);
